const RADIO_TYPES = ["radio", "button"];
const radioGroupKey = Symbol("RadioGroup");
export { RADIO_TYPES, radioGroupKey };
